import { APPS } from '../utils/cloudStorage';
import { useState } from 'react';
import {
  Typography,
  Button,
  Stack,
  Card,
  CardContent,
} from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LoginIcon from '@mui/icons-material/Login';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import RenewSubscriptionModal from './RenewSubscriptionModal';
import { useAuthStore } from '../store/authStore';
import { useNavigate } from 'react-router-dom';
import { useSubscriptionStatus } from './useSubscriptionStatus';

export default function ActivarSuscripcionBanner({ appKey, appName }) {
  const [open, setOpen] = useState(false);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const navigate = useNavigate();
  const { status, expiresAtLabel } = useSubscriptionStatus(appKey);

  if (APPS[appKey]?.premium === false) return <Card variant="outlined"><CardContent><Typography>{appName} es gratis, sin suscripción.</Typography>{!isAuthenticated && <Button onClick={() => navigate('/login')}>Comenzar gratis</Button>}</CardContent></Card>;

  if (isAuthenticated) {
    const isExpired = status === 'EXPIRED' || status === 'EXPIRED_SOFT' || status === 'EXPIRED_HARD';
    const title = isExpired ? 'Tu suscripción venció' : 'Tu prueba gratuita terminó';
    const description = isExpired
      ? expiresAtLabel
        ? `Tu suscripción de ${appName} venció el ${expiresAtLabel}. Renueva para volver a usar la aplicación.`
        : `Tu suscripción de ${appName} venció. Renueva para volver a usar la aplicación.`
      : `Activa tu suscripción para seguir usando ${appName} sin interrupciones. El pago es rápido y seguro.`;

    return (
      <>
        <Card
          variant="outlined"
          sx={{
            textAlign: 'center',
            py: 4,
            px: 3,
            bgcolor: isExpired ? 'error.50' : 'warning.50',
            borderColor: isExpired ? 'error.300' : 'warning.300',
          }}
        >
          <CardContent>
            {isExpired ? (
              <EventBusyIcon color="error" sx={{ fontSize: 48, mb: 1 }} />
            ) : (
              <LockOpenIcon color="warning" sx={{ fontSize: 48, mb: 1 }} />
            )}
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              {title}
            </Typography>
            <Typography color="text.secondary" sx={{ maxWidth: 500, mx: 'auto', mb: 3 }}>
              {description}
            </Typography>
            <Button
              variant="contained"
              size="large"
              onClick={() => setOpen(true)}
              sx={{ fontWeight: 'bold', px: 5, py: 1.5 }}
            >
              {isExpired ? 'Renovar suscripción' : 'Activar suscripción'}
            </Button>
          </CardContent>
        </Card>

        <RenewSubscriptionModal
          open={open}
          onClose={() => setOpen(false)}
          appName={appName}
          appKey={appKey}
        />
      </>
    );
  }

  return (
    <Card
      variant="outlined"
      sx={{
        textAlign: 'center',
        py: 4,
        px: 3,
        bgcolor: 'grey.50',
        borderColor: 'grey.300',
      }}
    >
      <CardContent>
        <LoginIcon color="primary" sx={{ fontSize: 48, mb: 1 }} />
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Inicia sesión para comenzar
        </Typography>
        <Typography color="text.secondary" sx={{ maxWidth: 500, mx: 'auto', mb: 3 }}>
          Crea tu cuenta o inicia sesión para probar <strong>{appName}</strong> gratis
          por 30 días, o activa tu suscripción.
        </Typography>
        <Stack direction="row" spacing={2} justifyContent="center">
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/login')}
            sx={{ fontWeight: 'bold', px: 4 }}
          >
            Iniciar sesión
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}
